import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './RestaurantsCard.css';
import React, { memo } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { canUseDOM, get, getListingItemURL, getMediaHost, injectImageResolution, pathJoin } from '../../../utils';
import { isNil, isNotNil } from '../../../utils/IsNil';
import RouterLink from '../RouterLink';
import LazyPicture from '../LazyPicture';
import TripAdvisor from '../TripAdvisor/TripAdvisor';
import FavouriteBtn from '../FavouriteBtn/FavouriteBtn';
import { ReactComponent as MichelinGreenStar } from '../../../resources/icons/michelinGreenStar.svg';
import { ReactComponent as MichelinRedStar } from '../../../resources/icons/michelinRedStar.svg';
import { HighlighterHOC } from '../HighlighterHOC/HighlighterHOC';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var allAvailableMatchesOfCountRedStars = {
  "one": 1,
  "1": 1,
  "two": 2,
  "2": 2,
  "three": 3,
  "3": 3
};
var defaultEmptyAnalyticObject = {
  bannerClickAnalytics: null,
  titleClickAnalytics: null,
  addToFavoriteClickAnalytics: null,
  removeFromFavoriteClickAnalytics: null
};
var RestaurantsCard = /*#__PURE__*/memo(function (_ref) {
  var item = _ref.item,
    reviews = _ref.reviews,
    rtl = _ref.rtl,
    analyticsCallback = _ref.analyticsCallback,
    textToHighlight = _ref.textToHighlight,
    baseHrefLink = _ref.baseHrefLink,
    _ref$isGetFullUrl = _ref.isGetFullUrl,
    isGetFullUrl = _ref$isGetFullUrl === void 0 ? false : _ref$isGetFullUrl,
    params = _ref.params;
  var analyticObject = function () {
    if (isNil(analyticsCallback)) {
      return defaultEmptyAnalyticObject;
    }
    return analyticsCallback;
  }();
  var hrefLink = canUseDOM ? baseHrefLink ? baseHrefLink : window.location.href : "";
  var tripAdvRatingImage = get(item, 'tripadvisorImage');
  var mainTripadvisorPrice = get(item, 'tripadvisorPrice');
  var mainTripadvisorReviews = get(item, 'tripadvisorReviews');
  var tripAdvScore = get(item, 'tripadvisorScore');
  var itemCategory = get(item, 'category');
  var michelinStarName = get(item, 'michelinStarName'); // Always has ENGLISH translation -> DON`T show this
  var michelinStarTitle = get(item, 'michelinStarTitle'); // Has MULTIPLE translation -> show only this

  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), item.image])), 340, 243);
  var getHref = function getHref() {
    return isGetFullUrl ? item.url : getListingItemURL(hrefLink, item.urlSlug, item.url);
  };
  var DefineCountOfMichelinStars = function DefineCountOfMichelinStars() {
    var textVersionOfRedStarsCount = null;

    // check for green star
    if (michelinStarName[0].toLowerCase().includes("green")) {
      return /*#__PURE__*/React.createElement(MichelinGreenStar, {
        className: "michelinStar"
      });
    }

    // check for count of red stars
    Object.entries(allAvailableMatchesOfCountRedStars).some(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        textVersionOfRedStars = _ref3[0];
      if (michelinStarName[0].toLowerCase().includes(textVersionOfRedStars)) {
        textVersionOfRedStarsCount = textVersionOfRedStars;
        return true;
      }
    });
    if (isNotNil(textVersionOfRedStarsCount)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, new Array(allAvailableMatchesOfCountRedStars[textVersionOfRedStarsCount]).fill(null).map(function () {
        return /*#__PURE__*/React.createElement(MichelinRedStar, {
          className: "michelinStar"
        });
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrap"
  }, item.image ? /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "link__a",
    title: "poi link",
    "aria-label": "link",
    href: getHref(),
    onClick: function onClick() {
      if (analyticObject.bannerClickAnalytics) {
        tealiumClickFunc(tealiumMergeClickData(analyticObject.bannerClickAnalytics, params), item.title);
      }
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "image",
    src: imgSrc,
    alt: item.title
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    className: "info_scrollAnimation"
  }, item && michelinStarTitle && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DefineCountOfMichelinStars, null), /*#__PURE__*/React.createElement("span", {
    className: "text-michelinStar"
  }, michelinStarTitle)), item && isNil(michelinStarTitle) && itemCategory && /*#__PURE__*/React.createElement("div", {
    className: "text-cuisine"
  }, /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: itemCategory.join(', '),
    searchString: textToHighlight
  })), item && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "item-title",
    href: getHref(),
    onClick: function onClick() {
      if (analyticObject.titleClickAnalytics) {
        tealiumClickFunc(tealiumMergeClickData(analyticObject.titleClickAnalytics, params), item.title);
      }
    }
  }, item ? /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: item.title,
    searchString: textToHighlight
  }) : null), /*#__PURE__*/React.createElement("p", {
    className: "body-small text"
  }, item ? /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: item.info || item.introText,
    searchString: textToHighlight
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "tripAdvisorContainer"
  }, /*#__PURE__*/React.createElement(TripAdvisor, {
    imageRatingSRC: tripAdvRatingImage,
    score: tripAdvScore,
    alt: "Tripadvisor",
    tripadvisorReviews: mainTripadvisorReviews,
    tripadvisorPrice: mainTripadvisorPrice,
    reviewCaption: reviews
  }))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: item && item.objectID,
    checkFavouriteButton: item && item.objectID,
    classes: "fav-btn",
    analyticsClick: function analyticsClick(buttonTitle, active) {
      if (active) {
        analyticObject.removeFromFavoriteClickAnalytics && tealiumClickFunc(tealiumMergeClickData(analyticObject.removeFromFavoriteClickAnalytics, params), item.title);
      } else {
        analyticObject.addToFavoriteClickAnalytics && tealiumClickFunc(tealiumMergeClickData(analyticObject.addToFavoriteClickAnalytics, params), item.title);
      }
    }
  }))));
});
var commonStyles = "c7h740z";
var ltrStyles = "luf3mwf";
var rtlStyles = "r15ns9pm";
export { RestaurantsCard };